import React from 'react';
import CustomFieldsSettings from '../components/Settings/CustomFields';

function CustomFieldsRoute(props) {
  return <CustomFieldsSettings {...props} />;
}

export default CustomFieldsRoute;
